import PropTypes from 'prop-types';
import React, {Component} from 'react';
import TabClick from 'modules/common/TabClick';
import {FormattedMessage} from 'react-intl';
import {bgBlue, scrollArea, bgBlueLight, preWrap} from './styles.scss';
import CodeTimeLine from './CodeTimeLine';

class QuestionContent extends Component {
  static propTypes = {
    task: PropTypes.object.isRequired,
    currentPosition: PropTypes.number.isRequired,
    challenges: PropTypes.array.isRequired,
    description: PropTypes.string.isRequired,
  };

  render() {
    return (
      <TabClick
        color={bgBlueLight}
        title={<FormattedMessage id="question" />}
        points={
          <div className={`pv1 ph3 ${bgBlue} white br4 mh2`}>
            20 <FormattedMessage id="points_max" />
          </div>
        }
      >
        <div className="pr2">
          <div className={`${scrollArea} pa3 ltr`}>
            <p
              className="tr pv3 rtl"
              dangerouslySetInnerHTML={{
                __html: this.props.description,
              }}
            />
            <CodeTimeLine
              currentPosition={this.props.currentPosition}
              challenges={this.props.challenges}
            />
            <p
              className={`ba bg-near-white tr pv3 rtl b--moon-gray ph3 br2 ${preWrap}`}
              dangerouslySetInnerHTML={{
                __html: this.props.task.description,
              }}
            />
          </div>
        </div>
      </TabClick>
    );
  }
}

export default QuestionContent;
